import { inject, Injectable } from '@angular/core';
import { HttpService } from '@services/http.service';
import { SynchronizationResponse } from '@models/synchronization/synchronization-response';
import { SyncStatus } from '@models/synchronization/sync-status';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SynchronizationService {
  private http = inject(HttpService);
  private readonly syncApi = `${environment.portageUrl}/shared/sync`;

  startSynchronization(){
    return this.http.get<SynchronizationResponse>(this.syncApi);
  }

  // Gardé pour debug uniquement — l'app ne poll plus le statut (modèle piloté par 423).
  getSyncStatus(){
    return this.http.get<SyncStatus>(`${this.syncApi}/status`);
  }
}
